import { departmentCreateFormSchema } from './create-form.js';
export const departmentEditFormSchema = departmentCreateFormSchema;
//# sourceMappingURL=update-form.js.map